import { makeStyles } from 'tss-react/mui';


export const useStyles = makeStyles()(theme => ({
  calendarRoot: {
    display: 'flex',
    position: 'relative',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    flex: 1,
    paddingLeft: theme.spacing(3),
    paddingTop: theme.spacing(2),

    '& .fc': {
      width: '100%',
    },

    '& .fc-highlight': {
      display: 'none',
    }
  },

  timeList: {
    listStyle: 'none',
    width: '100%',
    whiteSpace: 'nowrap',
    paddingLeft: 0,
    margin: 0,
    textAlign: 'right',
    lineHeight: '20px',
    fontSize: '14px',
    textTransform: 'none',
  },

  timeListEmpty: {
    textTransform: 'none',
    textAlign: 'left',
  },

  metrics: {
    backgroundColor: theme.palette.secondary.background,
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  loading: {
    position: 'absolute',
    left: '0px',
    top: '0px',
    width: '100%',
    height: '100%',
    zIndex: 1000,
  },
}));
